import React from 'react';
import {Route, Redirect, Switch} from 'react-router';
import {getPath} from 'epic-common/src/route';
import {MotdView, Error404, HomeView, Success, BlogWrapper, ArticleWrapper, FaqView} from '../views';
import EulaView from '../views/eula/EulaView';
import MobileView from '../views/mobile/MobileView';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}`;
    return (
        <Redirect to={redirectUrl} />
    );
};
const goHome = redirectLocale.bind(null, '/home');
const goNews = redirectLocale.bind(null, '/news');
const goNewsCat = redirectLocale.bind(null, ({category}) => `/news/category/${category}`);
const goNewsTitle = redirectLocale.bind(null, ({title}) => `/news/${title}`);
const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route
                exact path={`${path}:locale/blog`}
                render={goNews} />
            <Route exact path={`${path}:locale/`} render={goHome} />
            <Route path={`${path}:locale/blog/category/:category`} render={goNewsCat} />
            <Route path={`${path}:locale/blog/:articleLocale/category/:category`} render={goNewsCat} />
            <Route path={`${path}:locale/blog/:title`} render={goNewsTitle} />
            <Route path={`${path}:locale/home`} component={HomeView} />
            <Route
                exact path={`${path}:locale/news`}
                component={BlogWrapper} />
            <Route path={`${path}:locale/news/category/:category`} component={BlogWrapper} />
            <Route path={`${path}:locale/news/:title`} component={ArticleWrapper} />
            <Route path={`${path}:locale/faq`} component={FaqView} />
            <Route path={`${path}motd`} component={MotdView} />
            <Route path={`${path}:locale/register-success`} component={Success} />
            <Route path={`${path}:locale/motd`} component={MotdView} />
            <Route path={`${path}:locale/eula`} component={EulaView} />
            <Route path={`${path}:locale/mobile`} component={MobileView} />
            <Route path={`${path}:locale/page-not-found`} component={Error404} />
            <Route component={Error404} />
        </Switch>
    );
    return routes;
};

export default getRoutes;

